import { render } from "./RenderLayout.vue?vue&type=template&id=a9a05fe4"
import script from "./RenderLayout.vue?vue&type=script&lang=js"
export * from "./RenderLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__